export const DEMO_ASSETS_ROOT_URL = 'https://raw.githubusercontent.com/polygonjs/polygonjs-assets/master';
export const DEFAULT_FONT_URL_JSON = `${DEMO_ASSETS_ROOT_URL}/fonts/droid_sans_regular.typeface.json`;
export const DEFAULT_FONT_URL_TTF = `${DEMO_ASSETS_ROOT_URL}/fonts/SourceCodePro-BoldIt.ttf`;
